module.exports = __webpack_public_path__ + "static/media/GT.4766b57d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GT.svg
// module id = 2163
// module chunks = 7